/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/browser";

export function isAlgoliaApiError(e: unknown): e is Error & { status?: number } {
    return !!e && typeof e === "object" && (e as any).name === "ApiError";
}

export function isAuth0LoginRequired(err: unknown): boolean {
    if (!err || typeof err !== "object") return false;
    const any = err as any;
    const msg = String(any.message || any.error_description || "");
    const code = String(any.error || any.code || "");
    const status = Number(any.status || any.statusCode);

    return (
        code.toLowerCase() === "login_required" ||
        /login required/i.test(msg) ||
        (status === 401 && /login required/i.test(msg))
    );
}

export function isFromExtension(event: Sentry.Event): boolean {
    const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
    return frames.some((f) => {
        const file = (f.filename || "").toString();
        return (
            file.startsWith("chrome-extension://") ||
            file.startsWith("moz-extension://") ||
            file.startsWith("safari-extension://") ||
            /\/extensions?\//i.test(file)
        );
    });
}

export function matchesRpcMessage(event: Sentry.Event, hint?: Sentry.EventHint): boolean {
    const raw =
        event.exception?.values?.[0]?.value ??
        (hint?.originalException && String((hint.originalException as any).message || hint.originalException)) ??
        "";
    return /^Object Not Found Matching Id:\d+,\s*MethodName:update,\s*ParamCount:\d+$/i.test(String(raw));
}
